<template>
  <basic-container>
    <div class="blog-detail">
      <div class="banner_w3lspvt-2">
        <ol class="breadcrumb">
          <li class="breadcrumb-item" aria-current="page">{{$t('blog.title')}}</li>
        </ol>
      </div>
      <div class="page-wrapper">
        <div class="container">
          <div class="post-content" v-html="processedFieldI"></div>
          <p class="createDate">{{ detailsData.createDate }}</p>
          <p class="biaoqian">{{ detailsData.fieldC }}</p>
        </div>
      </div>
    </div>
  </basic-container>
</template>

<script>
import "@/assets/originCss/blog.css";
import { getDetail } from "@/api/blog/blog";
export default {
  name: "BlogDetail",
  data() {
    return {
      id: "",
      detailsData: {},
      processedFieldI:''
    };
  },
  created() {
  },
  mounted() {
    this.getDetailData();
  },
  methods: {
    getDetailData() {
     
      getDetail(this.$route.query.id).then((res) => {
        this.detailsData = res.data;
         // 处理 detailsData.fieldI 中的 img 标签
         if (this.detailsData.fieldI) {
          this.processedFieldI = this.addPrefixToImages(this.detailsData.fieldI);
        }
      });
    },
    // 根据id查找对象查找数组中指定id的对象
    findObjectById(array, id) {
      return array.find((item) => item.id === id);
    },
     // 添加前缀到 img 标签的 src 属性
     addPrefixToImages(htmlString) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, 'text/html');
      const images = doc.querySelectorAll('img');

      images.forEach(img => {
        const src = img.getAttribute('src');
        if (src && !src.startsWith('http')) { // 确保只处理相对路径
          img.setAttribute('src', 'https://journal.ac.cn/' + src); // 替换 '/your-prefix/' 为你实际需要的前缀
        }
      });

      return doc.body.innerHTML;
    },
  },
};
</script>
<style lang="scss" scoped>
.blog-detail {
}
</style>
